(function() { window.GUID_4bef8bc6_5b56_4ef6_aec6_072c7776b119 = { getGuid: function() { return "4bef8bc6-5b56-4ef6-aec6-072c7776b119"; } }; })();
////namespace CS.App.Views._Shared.WallSections {
////    CS.Controls.Accordion.Events.Ready({
////        selector: "body",
////        childSelector: ".accordion-operatorplayers",
////        callback: function (control, e) {
////            control.$Container.offon("click.player-box", ".operator-player-row", function (e) {
////                const $target = $(e.target)
////                alert('test');
////            });
////        }
////    });
////}

//# sourceMappingURL=operator-team-row.js.map
